import React from 'react';
import { getRatingSet, NURSING_ROLES } from '../evaluation.constants';

const EvaluationRatingKey = ({ selectedRole }) => {
    const ratings = getRatingSet(selectedRole);
    const isNursingRole = selectedRole && NURSING_ROLES.includes(selectedRole.toLowerCase());

    return (
        <div className={isNursingRole ? "flex flex-wrap items-center gap-x-8 gap-y-2 text-sm mb-4" : "grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-4"}>
            {ratings.map((rating) => (
                <div key={rating.value} className={isNursingRole ? "whitespace-nowrap" : ""}>
                    <span className="font-semibold">{rating.value}</span> = {rating.label.split(' – ')[1] || rating.label.split(' = ')[1] || rating.label}
                </div>
            ))}
        </div>
    );
};

export default EvaluationRatingKey;
